import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { TrainingHistory } from "./TrainingHistory";
import { ITrainingHistoryData } from "./TrainingHistoryData";
import { TrainingType } from "./TrainingHistoryModels";

export const TrainingHistoryRouteLoader = async ({ request }: { request: any, params: any }) =>
  doFetch('training-history', { signal: request.signal }, true, false);

export const TrainingHistoryRoute = () => {
  const data = useLoaderData() as ITrainingHistoryData;
  const [trainingType, setTrainingType] = useState(TrainingType.bcmea);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const onTabSelect = (tab: TrainingType) =>
    setTrainingType(prev => prev === tab ? prev : tab);

  const onShowDisclaimer = () => setShowDisclaimer(prev => !prev);
  return (
    <TrainingHistory
      data={data}
      onTabSelect={onTabSelect}
      selectedTab={trainingType}
      showDisclaimer={showDisclaimer}
      onShowDisclaimer={onShowDisclaimer}
    />
  )
}